import { render, staticRenderFns } from "./uiImage.vue?vue&type=template&id=1c67c927"
import script from "./uiImage.vue?vue&type=script&lang=js"
export * from "./uiImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports